import { Popover as MuiPopover } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router";

import {
  borderColor,
  hoverColor,
  inkColor,
  mutedColor,
  paperColor,
} from "~/styles/redesignColors";

export const Popover = styled(MuiPopover)(({ theme }) => ({
  "& .MuiPopover-paper": {
    marginTop: 6,
    padding: "14px 16px",
    border: `1px solid ${borderColor(theme)}`,
    borderRadius: 10,
    backgroundColor: paperColor(theme),
    backgroundImage: "none",
    boxShadow: "0 8px 28px rgba(11,12,14,.14)",
  },
}));

export const Content = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 12,
  width: 420,
  maxWidth: "100%",
  textAlign: "left",
});

export const Header = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 6,
});

export const Title = styled("h2")(({ theme }) => ({
  flex: "1 1 auto",
  margin: 0,
  fontSize: 13,
  fontWeight: 700,
  lineHeight: "normal",
  color: inkColor(theme),
}));

export const CloseButton = styled("button")(({ theme }) => ({
  display: "inline-flex",
  padding: 0,
  border: "none",
  background: "none",
  color: mutedColor(theme),
  cursor: "pointer",

  "& svg": {
    fontSize: 18,
  },
}));

export const Tabs = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 4,
  padding: 4,
  borderRadius: 999,
  backgroundColor: hoverColor(theme),
}));

export const Tab = styled("button", {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>(({ theme, active }) => ({
  flex: "1 1 0",
  minHeight: 30,
  border: "none",
  borderRadius: 999,
  backgroundColor: active ? paperColor(theme) : "transparent",
  boxShadow: active ? "0 1px 3px rgba(11,12,14,.12)" : "none",
  fontFamily: "inherit",
  fontSize: 12,
  fontWeight: active ? 700 : 500,
  whiteSpace: "nowrap",
  color: inkColor(theme),
  cursor: "pointer",
}));

export const Footer = styled("p")(({ theme }) => ({
  margin: 0,
  fontSize: 11,
  lineHeight: 1.45,
  color: mutedColor(theme),
}));

export const FooterLink = styled(Link)(({ theme }) => ({
  fontWeight: 600,
  color: inkColor(theme),
}));
